<section>
  <div class="inner-footer text-white px-4">
    <div class="footer-bottom pt-2">
      <div class="row">
        <div class="col-xl-10 col-lg-10 col-sm-10 col-12">
          <div>
            <p class="browser-compatibility footer-items mb-0">
              <span
                class="browser-compatibility-link me-3"
                [matTooltip]="
                  'Best viewed in Firefox 60+ | Google Chrome 70+ | IE Edge 90+ | Opera 58+ | Safari 12+'
                "
                >Browser Compatibility</span
              >

              <span
                class="browser-compatibility-link"
                (click)="openTermsDialog()"
                >Terms of Usage</span
              >
            </p>
          </div>
          <p class="footer-items mb-1">
            <!-- Copyright <span>&#169;</span> 2021 Tata Consultancy Services -->
            {{ isCopyRight }}
          </p>
        </div>
        <div class="col-xl-2 col-lg-2 col-sm-2 col-4 text-end">
          <img
            alt="DigiGOV logo"
            title="DigiGOV"
            src="./assets/images/footerlogoDG.svg"
            class="img-fluid"
          />
        </div>
      </div>
    </div>
  </div>
</section>
